<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="12"
        lg="12"
        class="pb-0"
      >
        <v-text-field
          v-model="ticket.ntdSerialNumber"
          label="NTD Serial number	"
          placeholder=" "
          outlined
          dense
          :readonly="false"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="12"
        lg="12"
        class="pb-0"
      >
        <v-text-field
          v-model="ticket.cpeName"
          label="What CPE is connected?"
          placeholder=" "
          outlined
          dense
          :readonly="false"
        ></v-text-field>
      </v-col>

      <v-col
        cols="12"
        md="12"
        lg="12"
        class="pb-0"
      >
        <v-text-field
          v-model="ticket.cpeMac"
          label="What is the CPE MAC address?	"
          placeholder=" "
          outlined
          dense
          :readonly="false"
        ></v-text-field>
      </v-col>



      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Power Status"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="PowerStatus"
            label="Power Status"
            name="Power Status"
            outlined
            placeholder="Please select Power Status"
            v-model="ticket.powerStatus"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Power Behaviour"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="LedBehaviour"
            label="Power Behaviour"
            name="Power Behaviour"
            outlined
            placeholder="Please select Power Behaviour"
            v-model="ticket.powerBehaviour"
          ></v-select>
        </ValidationProvider>
      </v-col>


      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Status Status"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="StatusStatus"
            label="Status Status"
            name="Status Status"
            outlined
            placeholder="Please select Status Status"
            v-model="ticket.statusStatus"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Status Behaviour"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="LedBehaviour"
            label="Status Behaviour"
            name="Status Behaviour"
            outlined
            placeholder="Please select Status Behaviour"
            v-model="ticket.statusBehaviour"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="ODU Status"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="PowerStatus"
            label="ODU Status"
            name="ODU Status"
            outlined
            placeholder="Please select ODU Status"
            v-model="ticket.oduStatus"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="ODU Behaviour"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="LedBehaviour"
            label="ODU Behaviour"
            name="ODU Behaviour"
            outlined
            placeholder="Please select ODU Behaviour"
            v-model="ticket.oduBehaviour"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="UNI-D Status"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="UnidStatus"
            label="UNI-D Status"
            name="UNI-D Status"
            outlined
            placeholder="Please select UNI-D Status"
            v-model="ticket.unidStatus"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="UNI-D Behaviour"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="LedBehaviour"
            label="UNI-D Behaviour"
            name="UNI-D Behaviour"
            outlined
            placeholder="Please select UNI-D Behaviour"
            v-model="ticket.unidBehaviour"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Signal Strength Status"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="StatusStatus"
            label="Signal Strength Status"
            name="Signal Strength Status"
            outlined
            placeholder="Please select Signal Strength Status"
            v-model="ticket.signalStrengthStatus"
          ></v-select>
        </ValidationProvider>
      </v-col>
      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Used Port"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="UsedPort"
            label="Used Port"
            name="Used Port"
            outlined
            placeholder="Please select Used Port"
            v-model="ticket.usedPort"
            onchange=""
          ></v-select>
        </ValidationProvider>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "nbn-check-list-details-wireless",
  props: {
    ticket: { type: Object },
  },
  data: () => ({
    PowerStatus: [
      {text: "Green", value: "Green", disabled: false},
      {text: "Red", value: "Red", disabled: false},
      {text: "Off", value: "Off", disabled: false},
    ],
    StatusStatus:[
      {text: "Amber", value: "Amber", disabled: false},
      {text: "Green", value: "Green", disabled: false},
      {text: "Red", value: "Red", disabled: false},
      {text: "Off", value: "Off", disabled: false},
    ],
    UnidStatus:[
      {text: "Amber", value: "Amber", disabled: false},
      {text: "Off", value: "Off", disabled: false},
    ],
    LedBehaviour: [
      {text: "Flashing", value: "Flashing", disabled: false},
      {text: "Solid", value: "Solid", disabled: false},
    ],
    UsedPort: [
      {text: "D1", value: "D1", disabled: false},
      {text: "D2", value: "D2", disabled: false},
      {text: "D3", value: "D3", disabled: false},
      {text: "D4", value: "D4", disabled: false},
      {text: "V1", value: "V1", disabled: false},
      {text: "V2", value: "V2", disabled: false},
    ],
  })
}
</script>

<style scoped>

</style>
